<template>
    <div class="container">
        <!-- Page title -->
        <div class="pt-5 pb-5">
            <h1 class="m-0">Winkelen</h1>
        </div>
        <!-- End Page title -->

        <div class="row">
            <div class="col-md-3">
                <!-- Sidebar -->
                <sidebar></sidebar>
                <!-- End Sidebar -->
            </div>
            <div class="col-md-9">
                <div class="panel">
                    <h3 class="mb-4">Vrij product toevoegen</h3>
                    <form @submit.prevent="addToCart">
                        <div class="form-group">
                            <label>Titel</label>
                            <input type="text" class="form-control" v-model="product.title" />
                            <form-errors :errors="errors['title']"></form-errors>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label>Categorie</label>
                                <select v-model="product.category_id" class="form-control">
                                    <option
                                        v-for="category in categoryList"
                                        :key="category.id"
                                        :value="category.id"
                                    >{{ category.title }}</option>
                                </select>
                                <form-errors :errors="errors['quantity']"></form-errors>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Aantal</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        min="1"
                                        v-model="product.quantity"
                                    />
                                    <form-errors :errors="errors['quantity']"></form-errors>
                                </div>
                            </div>
                        </div>
                        <div class="alert alert-info">
                            <i class="fa fa-info-circle mr-1"></i>
                            In het winkelmandje kan u indien nodig nog foto's toevoegen om uw gewenste product te verduidelijken.
                        </div>
                        <div class="d-flex">
                            <button class="btn btn--accent ml-auto" type="submit">
                                <i class="fa fa-spin fa-circle-o-notch mr-1" v-if="addingToCart"></i> Toevoegen
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            addingToCart: false,
            product: {
                title: "",
                quantity: 1,
                category_id: null
            },
            errors: {}
        };
    },
    computed: {
        categoryList() {
            return this.$store.getters.categoryList;
        }
    },
    methods: {
        addToCart() {
            if (this.addingToCart) {
                return;
            }

            this.addingToCart = true;

            this.$http
                .post("/cart/custom", this.product)
                .then(res => {
                    console.log(res);

                    this.$root.$emit("notify", {
                        type: "success",
                        text: res.data.message
                    });

                    this.product.title = "";
                    this.product.quantity = 1;
                    this.addingToCart = false;

                    this.errors = {};
                })
                .catch(err => {
                    console.log(err.response);
                    this.addingToCart = false;

                    if (err.response.status == 422) {
                        // Error message
                        // if (err.response.data.message) {
                        //     this.$root.$emit("notify", {
                        //         type: "error",
                        //         text: err.response.data.message
                        //     });
                        // }

                        // Errors
                        if (err.response.data.errors) {
                            this.errors = err.response.data.errors;
                        }
                    }
                });
        }
    }
};
</script>
